export const sweetAlert = {
  methods: {
    alert(options) {
      this.$swal(options)
    },
    alertSuccess({
      // title = 'Success!',
      text = '',
      icon = 'success',
      buttonsStyling = false,
      customClass = {
        confirmButton: 'btn btn-primary',
      },
    } = {}) {
      this.alert({
        // title,
        text,
        icon,
        buttonsStyling,
        type: 'success',
        customClass,
      })
    },
    alertSuccessCustom({
      text = '',
      icon = 'success',
      buttonsStyling = false,
      customClass = {
        confirmButton: 'btn btn-primary',
      },
      link = null,
      afterLinkText = '',
    } = {}) {
      // Get primary color from localStorage
      const storedThemeColors = JSON.parse(localStorage.getItem('themeColors') || '{}')
      const primaryColor = storedThemeColors?.primaryColor || '#007bff' // Fallback color

      let finalText = text
      if (link) {
        const linkHtml = `<a href="#" class="alert-router-link" style="color: ${primaryColor}; text-decoration: underline; cursor: pointer; font-weight: 500;">${link.text || 'Click here'}</a>`
        finalText = `${text}${linkHtml}${afterLinkText}`
      }

      this.alert({
        html: finalText,
        icon,
        buttonsStyling,
        type: 'success',
        customClass,
        didOpen: () => {
          if (link) {
            const linkElement = document.querySelector('.alert-router-link')
            if (linkElement) {
              linkElement.addEventListener('click', e => {
                e.preventDefault()

                if (this.$swal && this.$swal.close) {
                  this.$swal.close()
                }

                // Navigate to the route
                if (link.route) {
                  this.$router.push(link.route)
                } else if (link.path) {
                  this.$router.push(link.path)
                }
              })
            }
          }
        },
      })
    },

    applyPrimaryColor(color) {
      if (!color) return
      document.documentElement.style.setProperty('--primary', color, 'important')
    },
    alertInfo({
      // title = 'Success!',
      text = '',
      icon = 'info',
      // iconColor = 'btn btn-primary',
      buttonsStyling = false,
      customClass = {
        confirmButton: 'btn btn-primary',
      },
    } = {}) {
      this.alert({
        // title,
        text,
        icon,
        // iconColor,
        buttonsStyling,
        type: 'success',
        customClass,
      })
    },
    alertError({
      title = '',
      text = this.$t('Oops...Something went wrong'),
      icon = 'error',
      html = '',
      iconHtml = '',
      customClass = {
        confirmButton: 'btn btn-primary',
      },
    } = {}) {
      this.alert({
        title,
        text,
        html,
        icon,
        iconHtml,
        type: 'error',
        customClass,
      })
    },
    confirm(confirmCallback, {
      text = '',
      icon = 'warning',
      showCancelButton = true,
      cancelCallback = null, // Add optional cancel callback
      cancelButtonText = this.$t('No, thanks'),
      confirmButtonColor = '#DD6B55',
      confirmButtonText = this.$t('Yes, I want to proceed'),
      customClass = {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-danger ml-1',
      },
      buttonsStyling = false,
    } = {}) {
      this.$swal({
        html: `<strong>${text}</strong>`,
        icon,
        showCancelButton,
        confirmButtonColor,
        confirmButtonText,
        cancelButtonText,
        buttonsStyling,
        customClass,
      }).then(result => {
        if (result.isConfirmed) {
          confirmCallback()
        } else if (result.isDismissed && cancelCallback) {
          cancelCallback()
        }
      })
    },
    handleError(error) {
      if (error.response.data.errors) {
        const errorObject = Object.entries(error.response.data.errors).reduce((memo, [key, value]) => ({ ...memo, [key]: value.errorMessage }), {})
        return this.alertError({ text: Object.values(errorObject).toString() })
      }
      // return error.response.data.errors.forEach(responseError => {
      //   this.alertError({ text: responseError.errorMessage })
      // })
      // this.alertError({ text: error.response.data.errors[0].errorMessage })

      return this.alertError({ text: error })
    },
    readError(error) {
      if (error.response.data.errors) {
        const errorObject = Object.entries(error.response.data.errors).reduce((memo, [key, value]) => ({ ...memo, [key]: value.errorMessage }), {})
        return Object.values(errorObject).toString()
      }
      // return error.response.data.errors.forEach(responseError => {
      //   this.alertError({ text: responseError.errorMessage })
      // })
      // this.alertError({ text: error.response.data.errors[0].errorMessage })

      return error
    },
  },
}

export const _ = null
